import { GetCulpritCustomerImageTabsAlertsQueryParamType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerImageTabsAlerts/getCulpritCustomerImageTabsAlertsQuery.type';
import { getCulpritCustomerImageTabsAlertsQueryFunctions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerImageTabsAlerts/getCulpritCustomerImageTabsAlertsQueryFunctions';
import { queryOptions } from '@tanstack/react-query';

const getCulpritCustomerImageTabsAlertsQueryOptions = (
  params: GetCulpritCustomerImageTabsAlertsQueryParamType,
) =>
  queryOptions({
    queryKey: ['GET_Culprit_CUSTOMER_IMAGE_TABS_ALERTS', params],
    queryFn: () => getCulpritCustomerImageTabsAlertsQueryFunctions(params),
  });
export default getCulpritCustomerImageTabsAlertsQueryOptions;
